$(window).on('load', function () { 
    initAccordions();
});

function initAccordions() {
    $('.accordion__item').each(function () {

        // apply height of each accordion on load
        accordion_height = $(this).find('.accordion__content')[0].scrollHeight + $(this).find('.accordion__title').outerHeight();
        $(this).css('max-height', accordion_height);
    })

    $('.accordion__title').click(function () {
        var accordion_parent = $(this).parent();

        // Close nested accordions and open
        accordion_parent.toggleClass('accordion__item--open');

        // Update aria tags
        if (accordion_parent.attr('aria-expanded') === 'true') {
            accordion_parent.attr('aria-expanded', 'false');
        } else {
            accordion_parent.attr('aria-expanded', 'true');
        }

    }); 
}